//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as helpAction from '../action/helpAction';
import * as guideAction from '../action/guideAction';
//Material-ui
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

//Part
import PartPageTitle from './PartPageTitle';
import PartChargeCredit from './PartChargeCredit';
import PartChargeBank from './PartChargeBank';
import PartChargeBitcash from './PartChargeBitcash';


class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      tabValue: 'credit',
      credit: {
        money: 4960,
        days: 60,
      },
    }
	}

  componentDidMount() {
    document.title = '有料サービス - パートナーズ';
    window.scrollTo(0, 0);
  }



  render() {
    let comp;
    if (this.props.my.setting.chargeBan === 1) {
      comp = (
        <div>
          <h3 align='center'>有料サービスはご利用いただけません</h3>
          <div align='center' style={{padding:'10px'}}>お客様のアカウントは有料サービスに<br/>お申し込みいただけません</div>
        </div>
      )
    }
    else {
      comp = (
        <div>

          <div style={{padding:'5px', fontSize:'1',color:'#666'}}  align='center'>
            <div>メールが無制限にご利用いただけます。</div>
            <div>ポイント等の追加料金は一切ございません</div>

            <Button
              variant="outlined"
              color='primary'
              onClick={ () => this.props.guidePaymentSet(true, 'men') }
            >
              有料と無料サービスの違いについて
            </Button>
          </div>

          <h3 align='center'  style={{margin:'10px'}}>お支払方法を選択してください</h3>
          <Box boxShadow={1} style={{background:'#FFF',marginTop:'5px'}}>
            <Tabs
              value={this.state.tabValue}
              onChange={ (e, value) => this.setState({tabValue: value}) }
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab
                value="credit"
                label="クレジット"
                style={{fontSize:'1em',fontWeight:'bold'}}
              />
              <Tab
                value="bank"
                label="銀行振込"
                style={{fontSize:'1em',fontWeight:'bold'}}
              />
              <Tab
                value="bitcash"
                label={<span><span className='i-b'>ビット</span><span className='i-b'>キャッシュ</span></span>}
                style={{fontSize:'1em',fontWeight:'bold'}}
                wrapped
              />

            </Tabs>
          </Box>
          <Box boxShadow={1} style={{background:'#FFF',marginTop:'10px'}}>
            <div style={{paddingTop:'10px'}}>
              {
                (this.state.tabValue === 'credit') && (
                  <PartChargeCredit />
                )
              }
              {
                (this.state.tabValue === 'bank') && (
                  <PartChargeBank />
                )
              }
              {
                (this.state.tabValue === 'bitcash') && (
                  <PartChargeBitcash
                    history={this.props.history}
                  />
                )
              }
            </div>
          </Box>
        </div>
      )
    }

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'有料サービス'}
          onback={ '/setting/' }
        />

        { comp }


      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...helpAction,
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
